const BYDA_DISPLAY_TIME_ZONE = "Australia/Melbourne";

const bydaDisplayDateFormatter = new Intl.DateTimeFormat("en-AU", {
  timeZone: BYDA_DISPLAY_TIME_ZONE,
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

function formatDateParts(year: number, month: number, day: number): string {
  return bydaDisplayDateFormatter.format(new Date(Date.UTC(year, month - 1, day, 12, 0, 0)));
}

export function formatBydaDisplayDate(value?: string | Date | null): string {
  if (!value) return "";

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return bydaDisplayDateFormatter.format(value);
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymd) {
    return formatDateParts(Number(ymd[1]), Number(ymd[2]), Number(ymd[3]));
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return raw;
  }

  return bydaDisplayDateFormatter.format(parsed);
}
